import { handleActions } from 'redux-actions';
import { IChangeEmailToken, IAccountResponseError } from '../../account.data';
import { ROUTER_REQUEST } from '@ngrx/router-store';
import {
  AccountActionsEnum,
  ChangeEmailTokenError,
  ChangeEmailTokenSuccess,
} from '../actions';

export interface IState {
  error: Error | IAccountResponseError;
  processing: boolean;
  token: IChangeEmailToken;
}

export const initialState: IState = {
  error: null,
  processing: false,
  token: null,
};

const reducerFn = handleActions(
  {
    // clear the error when user navigates to a different route
    [ROUTER_REQUEST]: function (state: IState) {
      return {
        ...state,
        error: null,
        token: null,
      };
    },
    [AccountActionsEnum.CHANGE_EMAIL_TOKEN]: function (state: IState) {
      return {
        ...state,
        error: null,
        processing: true,
        token: null,
      };
    },
    [AccountActionsEnum.CHANGE_EMAIL_TOKEN_SUCCESS]: function (
      state: IState,
      { payload }: ChangeEmailTokenSuccess
    ) {
      return {
        ...state,
        error: null,
        processing: false,
        token: payload,
      };
    },
    [AccountActionsEnum.CHANGE_EMAIL_TOKEN_ERROR]: function (
      state: IState,
      { payload }: ChangeEmailTokenError
    ) {
      return {
        ...state,
        error: payload.error,
        processing: false,
      };
    },
  } as any,
  initialState
);

export function reducer(state: IState, action: any) {
  return reducerFn(state, action);
}
